import { render, staticRenderFns } from "./CommuniqueCard.vue?vue&type=template&id=d6b3538a&scoped=true"
import script from "./CommuniqueCard.vue?vue&type=script&lang=js"
export * from "./CommuniqueCard.vue?vue&type=script&lang=js"
import style0 from "./CommuniqueCard.vue?vue&type=style&index=0&id=d6b3538a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b3538a",
  null
  
)

export default component.exports